export interface IPartnerCodesState {
  list: any[];
  loading: boolean;
}

export const initialUIState: IPartnerCodesState = {
  list: [],
  loading: false,
};